import { zodResolver } from '@hookform/resolvers/zod';
import { Button } from 'components/ui/button';
import { Card, CardContent, CardHeader } from 'components/ui/card';
import { Form, FormControl, FormField, FormItem, FormLabel, FormMessage } from 'components/ui/form';
import { Input } from 'components/ui/input';
import { useAuth } from 'global-hooks/use-auth';
import * as ReactHookForm from 'react-hook-form';
import { Link } from 'react-router-dom';
import { urlConfig } from 'utils/url-config';
import { z } from 'zod';

const formSchema = z.object({
	user_email: z.string().min(2).max(50).email(),
	user_password: z.string().min(6).max(50),
});

const Login = () => {
	const { isButtonDisabled, login } = useAuth();

	const form = (ReactHookForm as any).useForm({
		resolver: zodResolver(formSchema),
		defaultValues: {
			user_email: '',
			user_password: '',
		},
	});

	function onSubmit(values: any) {
		login({ authState: values, callbackUrl: urlConfig.pages.main });
	}
	return (
		<div className="w-screen h-screen flex items-center justify-center">
			<Card>
				<CardHeader>
					<h2 className="text-2xl font-bold">Sign in</h2>
					<span>Enter your email and password to sign in</span>
				</CardHeader>
				<CardContent>
					<Form {...form}>
						<form onSubmit={form.handleSubmit(onSubmit)} className="flex flex-col gap-3">
							<FormField
								control={form.control}
								name="user_email"
								// eslint-disable-next-line @typescript-eslint/no-explicit-any
								render={({ field }: any) => (
									<FormItem>
										<FormLabel>Email</FormLabel>
										<FormControl>
											<Input placeholder="example@email.com" type="email" {...field} />
										</FormControl>
										<FormMessage />
									</FormItem>
								)}
							/>
							<FormField
								control={form.control}
								name="user_password"
								// eslint-disable-next-line @typescript-eslint/no-explicit-any
								render={({ field }: any) => (
									<FormItem>
										<FormLabel>Password</FormLabel>
										<FormControl>
											<Input placeholder="******" type="password" {...field} />
										</FormControl>
										<FormMessage />
									</FormItem>
								)}
							/>

							<div className="flex flex-col gap-2">
								<Button type="submit" className="w-full" disabled={isButtonDisabled}>
									Submit
								</Button>
								<Link to={urlConfig.pages.register} className="text-sm text-blue-800 text-center">
									Do not have an account? Sign up
								</Link>
							</div>
						</form>
					</Form>
				</CardContent>
			</Card>
		</div>
	);
};
export default Login;
